import { axiosNT, axiosNTL } from '../../../services/axios';
import { UserBody } from '../types/UsersBody';
import axios from '../../../services/axios';

const list = () => {
	return axiosNT.get('/user/fetchUsers')
		.then((res: any) => {
			let users: UserBody[] = res.responseObject;
			return Promise.resolve(users);
		});
}

const newUser = (formData: any) => {
	return axios.post('/user/register', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
		.then((res: any) => {
			let status = res.statusCode;
			return Promise.resolve(status);
		});
}

const updateUser = (formData: any) => {
	return axios.patch('/user/updateUser', formData)
		.then((res: any) => {
			let resp = res.responseObject;
			return Promise.resolve(resp);
		});
}

const userCount = () => {
	return axiosNTL.get('/user/count')
		.then((res: any) => {
			let resp = res.responseObject && res.responseObject > 0 ? res.responseObject : 0;
			return Promise.resolve(resp);
		})
}

const removeUserRole = (id: string, roleId: string, miniLibraryId: string) => {
	return axios.get(`/user/removeRole/${id}/${roleId}/${miniLibraryId}`)
		.then((res: any) => {
			let resp = res.responseObject;
			return Promise.resolve(resp);
		})
}

const deleteUser = (userData: any) => {
	return axios.patch(`/user/deleteUser`, userData)
		.then((res: any) => {
			let rsp = res.responseObject;
			return Promise.resolve(rsp);
		})
}

export const userServices = {
	list,
	newUser,
	updateUser,
	userCount,
	removeUserRole,
	deleteUser
};